import { render, staticRenderFns } from "./AlipayAccountSecurityPage.vue?vue&type=template&id=3c51738a&scoped=true"
import script from "./AlipayAccountSecurityPage.vue?vue&type=script&lang=js"
export * from "./AlipayAccountSecurityPage.vue?vue&type=script&lang=js"
import style0 from "./AlipayAccountSecurityPage.vue?vue&type=style&index=0&id=3c51738a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c51738a",
  null
  
)

export default component.exports